// src/hooks/useAuth.js
import { useState, useEffect, createContext, useContext } from 'react';
import { auth, db } from '../lib/firebase';
import { onAuthStateChanged, signOut as firebaseSignOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { getMerchant } from '../lib/MerchantModel';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]               = useState(null);
  const [merchant, setMerchant]       = useState(null);
  const [adminMerchant, setAdminMerchant] = useState(null); // merchant admin is currently viewing
  const [isAdmin, setIsAdmin]         = useState(false);
  const [loading, setLoading]         = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        const adminSnap = await getDoc(doc(db, 'admins', firebaseUser.email));
        const admin = adminSnap.exists();
        setIsAdmin(admin);
        if (admin) {
          setMerchant(null);
        } else {
          const data = await getMerchant(firebaseUser.uid);
          setMerchant(data);
        }
      } else {
        setUser(null);
        setMerchant(null);
        setAdminMerchant(null);
        setIsAdmin(false);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const signOut = async () => {
    await firebaseSignOut(auth);
  };

  // What the dashboard/tables/sessions pages should use —
  // either the real merchant or the one admin is impersonating
  const activeMerchant = adminMerchant || merchant;

  return (
    <AuthContext.Provider value={{
      user,
      merchant: activeMerchant,
      isAdmin,
      adminMerchant,
      setAdminMerchant,
      loading,
      signOut,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);